import React from 'react'
import { FaMoneyBill } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { truncate, useGlobalState } from '../store'

const JobBid = ({ jobListing }) => {
  const [connectedAccount] = useGlobalState('connectedAccount')

  const getBidStatus = () => {
    if (jobListing.freelancer === connectedAccount) {
      return {
        message: 'Bid accepted! You can now find this project in "My Jobs".',
        status: 'accepted',
        color: 'text-green-500',
      }
    }

    if (
      jobListing.freelancer !== '0x0000000000000000000000000000000000000000' &&
      jobListing.freelancer !== connectedAccount
    ) {
      return {
        message: 'Bid rejected. The client selected another freelancer.',
        status: 'rejected',
        color: 'text-red-500',
      }
    }

    if (jobListing.state === 0) {
      return {
        message: 'Applied and waiting for acceptance.',
        status: 'pending',
        color: 'text-yellow-500',
      }
    }

    return null
  }

  const bidStatus = getBidStatus()
  return (
    <div className="border-t border-b border-l border-r border-gray-300 py-6 px-5">
      <h4>{jobListing.jobTitle}</h4>
      <div className="flex mt-2 items-center">
        <FaMoneyBill className="text-md cursor-pointer" />
        <span className="text-md">
          ${jobListing.minBudget} - ${jobListing.maxBudget}
        </span>
      </div>
      <div className="flex items-center mt-3 text-sm flex-wrap gap-3">
        {jobListing.tags.length > 0
          ? jobListing.tags.map((tag, i) => (
              <button key={i} className="px-4 py-1 bg-gray-200 rounded-lg mr-2">
                {tag}
              </button>
            ))
          : null}
      </div>
            <p className="pr-7 mt-5 text-sm">{jobListing.description}</p>
      <div className="flex justify-between items-center mt-4">
        <p className="text-sm font-semibold">
          Client: <span>{truncate(jobListing.owner, 4, 4, 11)}</span>
        </p>
      </div>
      {bidStatus && (
        <div className={`mt-4 font-semibold ${bidStatus.color}`}>
          <p>{bidStatus.message}</p>
        </div>
      )}

      <div className="flex mt-5">
        {bidStatus?.status !== 'rejected' && (
          <Link
            to={`/chats/${jobListing.owner}`}
            className="flex items-center px-3 py-1 border-[1px] border-green-500 text-green-500 space-x-2 rounded-md"
          >
            <span className="text-sm">Chat with owner</span>
          </Link>
        )}
      </div>
    </div>
  )
}

export default JobBid
